/**
 * Maps an appliance category slug (e.g. "washing-machine") to the
 * human-readable label used in `harvest_components.appliance_category`
 * (e.g. "Washing Machine"). Returns null if the slug is unknown so callers
 * can decide whether to skip the category filter.
 */
export function getHarvestApplianceCategoryLabel(
  slug: string | null | undefined
): string | null {
  if (!slug) return null;
  const normalized = String(slug).toLowerCase().trim();
  const map: Record<string, string> = {
    "washing-machine": "Washing Machine",
    "washing machine": "Washing Machine",
    dishwasher: "Dishwasher",
    refrigerator: "Household Refrigerator",
    "household-refrigerator": "Household Refrigerator",
    "household refrigerator": "Household Refrigerator",
    fridge: "Household Refrigerator",
    dryer: "Dryer",
    "tumble-dryer": "Dryer",
    "tumble dryer": "Dryer",
    "washer-dryer": "Washer Dryer",
    "washer dryer": "Washer Dryer",
  };
  return map[normalized] ?? null;
}
